export default "__VITE_ASSET__BqFocQNu__"